import React from 'react';
import Text from './Text';

/**
 * EGGS Input Component
 * Form input field with EGGS design system styling
 */
export default function Input({
  label,
  error,
  helperText,
  required = false,
  className = '',
  ...props
}) {
  const inputClasses = [
    'w-full',
    'px-4 py-3',
    'font-burns font-extralight text-base',
    'text-eggs-dark',
    'bg-white',
    'border rounded-lg',
    'transition-all duration-200',
    'focus:outline-none focus:ring-2 focus:ring-offset-1',
    error 
      ? 'border-error focus:ring-error' 
      : 'border-gray-300 focus:border-eggs-yellow focus:ring-eggs-yellow',
    'disabled:bg-gray-100 disabled:cursor-not-allowed',
    'placeholder:text-gray-400'
  ].join(' ');

  return (
    <div className={`space-y-1.5 ${className}`}>
      {label && (
        <label className="block">
          <Text type="Body" variant="sm" weight="Strong">
            {label}
            {required && <span className="text-error ml-1">*</span>}
          </Text>
        </label>
      )}
      <input className={inputClasses} {...props} />
      {(error || helperText) && (
        <Text 
          type="Body" 
          variant="xs" 
          className={error ? 'text-error' : 'text-gray-500'}
        >
          {error || helperText}
        </Text>
      )}
    </div>
  );
}
